import React from "react";
import Navbar from "../../Componenets/Navbar";
import phone from "../../Assests/Globalimages/phone.png";
import email from "../../Assests/Globalimages/email.png";
import location from "../../Assests/Globalimages/location.png";
import Footer from "../../Componenets/Footer";
const index = () => {
  return (
    <div>
      
      <section class="hand-made-section">
        <div class="container">
          <div class="row d-flex justify-content-center align-items-center">
            <div class="col-lg-8">
              <div class="content-hand-made text-center">
                <h3>Get In Touch!</h3>
                <h1>Pure. Handmade. Nature's Best for Your Skin!</h1>
                <div class="button-hand-made mt-3">
                  <button
                    type="button"
                    class="btn-lg hand-made"
                    hrf="check-out.html"
                  >
                    Shop Now
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
      {/* <!-- mape sectionis started  --> */}
      <section class="map-section">
        <div class="container">
          <div class="row">
            <div class="col-lg-6">
              <div class="content-map">
                <div class="-map">
                  <iframe
                    src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3321.2135012001713!2d73.07859197479527!3d33.65162943877932!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x38df956064946871%3A0x5a416c48fd9dbf95!2sMARIAM%20MARRIAGE%20HALL!5e0!3m2!1sen!2s!4v1741155200306!5m2!1sen!2s"
                    width="100%"
                    height="314px"
                    style={{ border: "0" }}
                    allowfullscreen=""
                    loading="lazy"
                    referrerpolicy="no-referrer-when-downgrade"
                  ></iframe>
                </div>
                <div class="content-contact">
                  <h4>Contact Us</h4>
                  <div class="mobile">
                    <div class="phone d-flex align-items-center">
                      <img src={phone} class="img-fluid phone-pic" alt="" />
                      <h5>Phone</h5>
                    </div>
                    <p>123 Fifth Avenue, New York, NY 10160</p>
                  </div>
                  <div class="mobile">
                    <div class="phone d-flex align-items-center">
                      <img src={email} class="img-fluid email-pic" alt="" />
                      <h5>Email</h5>
                    </div>
                    <p>contact@info.com</p>
                  </div>
                  <div class="mobile">
                    <div class="phone d-flex align-items-center">
                      <img
                        src={location}
                        class="img-fluid location-pic"
                        alt=""
                      />
                      <h5>Address</h5>
                    </div>
                    <p>9-334-7565-9787</p>
                  </div>
                </div>
              </div>
            </div>
            <div class="col-lg-6">
              <div class="contact-form">
                <form>
                  <div class="mb-5 form-bt">
                    <label for="name" class="form-label">
                      Name*
                    </label>
                    <input
                      type="text"
                      class="form-control"
                      id="name"
                      placeholder="Enter Name"
                    />
                  </div>
                  <div class="mb-5 form-bt">
                    <label for="email" class="form-label">
                      Email*
                    </label>
                    <input
                      type="email"
                      class="form-control"
                      id="email"
                      placeholder="abc@gmail.com"
                    />
                  </div>
                  <div class="mb-5 form-bt">
                    <label for="message" class="form-label">
                      Message
                    </label>
                    <textarea
                      class="form-control"
                      id="message"
                      rows="3"
                      placeholder="message"
                    ></textarea>
                  </div>
                  <button type="submit " class="form-btn">
                    shop now
                  </button>
                </form>
              </div>
            </div>
          </div>
        </div>
      </section>
      <section class="email-section">
        <div class="container">
          <div class="newsletter-container">
            <span class="newsletter-text">Subscribe to our newsletter</span>
            <div class="inputs-btn d-flex">
              <input
                type="email"
                class="newsletter-input"
                placeholder="Your email address..."
              />
              <button class="newsletter-button">SUBSCRIBE</button>
            </div>
          </div>
        </div>
      </section>
      <Footer />
    </div>
  );
};

export default index;
